"use client"
import styled from "@emotion/styled"
import { GetPageByRouteQuery } from "apollo"
import { useInView } from "react-intersection-observer"
import {
  AnimatedTypography,
  transitionDelayTime,
  TransitionUp,
  useInViewConfig,
} from "ui"
import Container from "ui/Container"
import {
  extractProperty,
  getNonUmbracoUrl,
  Link,
  ravKavLocateStations,
  replaceRichTextLinks,
  transformProperties,
} from "utils"

type Props = {
  data: any
  stationsData: GetPageByRouteQuery
}

const StyledDiv = styled.div`
  width: 100%;
  padding-top: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 48px;
  }
`

const StyledItemListWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  padding-top: 24px;
`

const StyledLinkDiv = styled(Link)`
  text-decoration: none;
  color: #008761;
  font-size: 20px;
  height: 48px;
  padding: 16px;
  border: 1px solid #008761;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  display: flex;
`

const StyledTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
const MultyURLS = ({ data, stationsData }: Props) => {
  const title = extractProperty(data, "title")
  const text = extractProperty(data, "text")
  const itemsList = extractProperty(data, "itemsList")
  const parsedData = stationsData?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const ravKavStation = blocks.blocks.find(
    (b: any) => b.blockType === "ravKavServiceStation",
  )
  const stationsList = extractProperty(ravKavStation, "itemsList")
  const { ref, inView } = useInView(useInViewConfig)
  return (
    <StyledDiv ref={ref}>
      <Container paddingMobile>
        <StyledTextBox>
          <AnimatedTypography variant="h3" $inview={inView}>
            {title}
          </AnimatedTypography>
          {text && (
            <AnimatedTypography
              variant="body1"
              $inview={inView}
              component="div"
              dangerouslySetInnerHTML={{
                __html: replaceRichTextLinks(text),
              }}
            ></AnimatedTypography>
          )}
        </StyledTextBox>
        <StyledItemListWrapper>
          {itemsList.map((item: any, index: number) => {
            // Extract the URL fragment (part after #) from the item URL
            const urlFragment = item?.url?.split("#")[1]

            // Find the matching station in stationsList by encorID
            const matchingStation = stationsList?.find((station: any) => {
              const encorID = extractProperty(station, "encorID")
              return encorID === urlFragment
            })

            // Use the tab name from matching station, fallback to item name
            const displayName = matchingStation
              ? extractProperty(matchingStation, "tab")
              : item?.name

            return (
              <TransitionUp
                key={index}
                $inView={inView}
                $delay={transitionDelayTime * 0.5 * index}
                style={{ width: "auto" }}
              >
                <StyledLinkDiv
                  href={getNonUmbracoUrl(item?.url)}
                  key={index}
                  onClick={() => {
                    ravKavLocateStations(displayName)
                  }}
                >
                  {displayName}
                </StyledLinkDiv>
              </TransitionUp>
            )
          })}
        </StyledItemListWrapper>
      </Container>
    </StyledDiv>
  )
}

export default MultyURLS
